/** @format */
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { Link, useNavigate } from "react-router-dom";
import * as formik from "formik";
import * as yup from "yup";
import {
  useUserRegister,
  useUserSignIn,
} from "../../../../../../api/mutations/auth.mutation";
import { signInSuccess } from "../../../../../../store";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../../../store/hook";
import * as RoleSelector from "src/store/role/selector";
import "react-phone-input-2/lib/bootstrap.css";
import PhoneInput from "react-phone-input-2";
import { useGetUserMe } from "../../../../../../api/queries/user.query";

function AboutForm() {
  const { Formik } = formik;

  const schema = yup.object().shape({
    first_name: yup.string().required("Please enter your first name"),
    last_name: yup.string().required("Please enter your last name"),
    email: yup
      .string()
      .email("Invalid email")
      .required("Please enter your email"),
    address: yup.string().required("Please enter your address"),
    number: yup.string().required("Please enter your phone number"),
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = useAppSelector(RoleSelector.selectUserRole);

  const userLoginMutation = useUserSignIn({
    onSuccess: (data) => {
      dispatch(signInSuccess("token"));
      navigate("/u");
    },
    onError: (error) => {
      if (error.message) {
        // Handle error here
      }
    },
    successMessage: "Login Successful!",
  });

  const onSignIn = (data) => {
    console.log(data);
    userLoginMutation.mutate({
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      address: data.address,
      number: data.number,
    });
  };

  const { data: userData, isLoading: isLoadingUserData } = useGetUserMe({
    select: (response) => response.data.user,
  });

  const initialValues = {
    first_name: userData?.firstname || "",
    last_name: userData?.lastname || "",
    email: userData?.email || "",
    address: userData?.address || "",
    number: userData?.number || "",
  };
  return (
    <Formik
      validationSchema={schema}
      onSubmit={onSignIn}
      initialValues={initialValues}
      enableReinitialize
    >
      {({ handleSubmit, handleChange, values, touched, errors }) => (
        <Form noValidate onSubmit={handleSubmit} className="">
          <Row className="mb-2">
            <h2 className="fs-4 mb-3">Contact Information</h2>
            <Form.Group
              as={Col}
              controlId="validationFormikFirstname"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">First Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Your First Name"
                name="first_name"
                value={values.first_name}
                onChange={handleChange}
                isInvalid={!!errors.first_name}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.first_name}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikLastname"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">Last Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Your Last Name"
                name="last_name"
                value={values.last_name}
                onChange={handleChange}
                isInvalid={!!errors.last_name}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.last_name}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikEmail"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Your Email"
                name="email"
                value={values.email}
                onChange={handleChange}
                isInvalid={!!errors.email}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikAddress"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">Address</Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Your Address"
                name="address"
                value={values.address}
                onChange={handleChange}
                isInvalid={!!errors.address}
                className="form-control mb-0"
                rows={4}
              />
              <Form.Control.Feedback type="invalid">
                {errors.address}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikPhoneNum"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Phone Number
              </Form.Label>
              <PhoneInput
                country={"my"}
                name="number"
                value={values.number}
                onChange={(phone) =>
                  handleChange({ target: { name: "number", value: phone } })
                }
                inputStyle={{
                  height: "30px",
                  fontSize: "14px",
                }}
                containerClass="custom-phone-input"
              />
              <Form.Control.Feedback type="invalid">
                {errors.number}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="text-end">
            <Button
              variant="success-subtle"
              type="submit"
              className="btn btn-success mt-4 fw-semibold text-uppercase"
            >
              Save & Update
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default AboutForm;
